import { handleRequestErrors } from "../services/handleRequestError";

export const fetchCustomersForOrders = (searchText) => {
  const endpoint = `/api/v1/customers/search_customers?text=${encodeURIComponent(searchText)}&serialized=true`;

  return (dispatch) => {
    fetch(endpoint, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      }
    })
      .then((res) => res.json())
      .then(
        (data) => dispatch({ type: 'SET_CUSTOMERS_FOR_ORDERS', data }),
        (err) => dispatch({ type: 'LOAD_DATA_FAILURE', err })
      ).catch((error) => {
        if (error.response) {
          alert(error.response);
        } else {
          alert("An unexpected error occurred.");
        }
      });
  };
};

export const fetchCustomers = (searchText = '', limit = 10) => {
  const endpoint = `/api/v1/customers/search_customers?text=${encodeURIComponent(searchText)}&serialized=true&limit=${limit}`;

  return (dispatch) => {
    fetch(endpoint, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      }
    })
      .then((res) => res.json())
      .then(
        (data) => dispatch({ type: 'SET_CUSTOMERS_INDEX', data }),
        (err) => dispatch({ type: 'LOAD_DATA_FAILURE', err })
      ).catch((error) => {
        if (error.response) {
          alert(error.response);
        } else {
          alert("An unexpected error occurred.");
        }
      });
  };
};

export const fetchCustomersByPermission = (searchText = '', limit = 10) => {
  const endpoint = `/api/v1/customers/search_assigned_customers?text=${encodeURIComponent(searchText)}&serialized=true&limit=${limit}`;

  return (dispatch) => {
    fetch(endpoint, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      }
    })
      .then((res) => res.json())
      .then(
        (data) => dispatch({ type: 'SET_CUSTOMERS_INDEX', data }),
        (err) => dispatch({ type: 'LOAD_DATA_FAILURE', err })
      ).catch((error) => {
        if (error.response) {
          alert(error.response);
        } else {
          alert("An unexpected error occurred.");
        }
      });
  };
};

export const createCustomer = (body) => {
  const endpoint = `/api/v1/customers`;

  return (dispatch) => {
    fetch(endpoint, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    })
      .then(handleRequestErrors)
      .then((data) => dispatch({ type: 'CREATE_AUTOMATIC_ANSWER', data })).catch((error) => {
        dispatch({ type: "LOAD_DATA_FAILURE", error });
      });
  };
};

export const createCustomerFromDirectMessage = (body) => {
  const endpoint = `/api/v1/customers/create_from_direct_message`;

  return (dispatch) => {
    fetch(endpoint, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    })
      .then((res) => handleRequestErrors(res, false))
      .then((data) => dispatch({ type: 'CREATE_CUSTOMER_FROM_CHAT', data })).catch((error) => {
        dispatch({ type: "LOAD_DATA_FAILURE", error });
      });
  };
};

export const updateCustomerFromChat = (id, body, token) => {
  const endpoint = `/api/v1/customers/${id}`;
  const csrfToken = token;
  return (dispatch) => {
    fetch(endpoint, {
      method: "PUT",
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': csrfToken,
        'Content-Type': 'application/json',
        'Accept': 'application/json, text/plain, */*'
      },
      body: JSON.stringify(body)
    })
      .then((res) => handleRequestErrors(res, false))
      .then((data) => {
        dispatch({ type: 'SET_CUSTOMER', data });
        dispatch({ type: 'SET_CUSTOMER_UPDATED_FOR_CHATS', data });
      }).catch((error) => {
        dispatch({ type: "LOAD_DATA_FAILURE", error });
      });
  };
};

export const addCustomerTags = (id, body) => {
  const endpoint = `/api/v1/customers/${id}/add_tags`;

  return (dispatch) => {
    fetch(endpoint, {
      method: "POST",
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        'Accept': 'application/json, text/plain, */*'
      },
      body: JSON.stringify(body)
    })
      .then((res) => handleRequestErrors(res, false))
      .then((data) => {
        dispatch({ type: 'SET_CUSTOMER', data });
        dispatch({ type: 'SET_CUSTOMER_UPDATED_FOR_CHATS', data });
      }).catch((error) => {
        dispatch({ type: "LOAD_DATA_FAILURE", error });
      });
  };
};

export const toggleMiaChatbot = (id, token, params) => {
  const endpoint = `/api/v1/customers/${id}/toggle_mia_chatbot`;
  const csrfToken = token;

  return (dispatch) => fetch(endpoint, {
    method: 'PUT',
    credentials: 'same-origin',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': csrfToken,
      'Content-Type': 'application/json',
      Accept: 'application/json, text/plain, */*'
    },
    body: JSON.stringify(params)
  })
    .then((res) => handleRequestErrors(res, false))
    .then((data) => {
      dispatch({ type: 'SET_CUSTOMER', data });
      dispatch({ type: 'SET_CUSTOMER_UPDATED_FOR_CHATS', data });
      return data;
    })
    .catch((error) => {
      dispatch({ type: 'LOAD_DATA_FAILURE', error });
      throw error;
    });
};
